import { requireTranslations } from '../../../translation';

export default requireTranslations((locale: string) => require(`./date.${locale}.json`));
